<template>
  <div class="w-100 border rounded shadow p-3 ">
    <div class="form-row mb-3">
      <div class="form-group col-md-6">
        <label for="procurement-name-hy">Մրցույթի անվանում</label>
        <input 
          v-model="$v.tender.title.$model"
          type="text"
          class="form-control"
          id="procurement-name-hy"
        >
      </div>
      <div class="form-group col-md-6">
        <label for="procurement-name-ru">Մրցույթի ծածկագիր</label>
        <input 
          v-model.number="$v.tender.passwordTender.$model"
          type="text"
          class="form-control"
          id="procurement-name-ru"
        >
      </div>
      <div class="form-group col-md-6">
        <label for="start-date">Սկիզբ</label>
        <date-pick
          v-model="$v.tender.start_date.$model"
          :isDateDisabled="previousDate"
          :displayFormat="'YYYY-MM-DD'"
          :inputAttributes="{readonly: true}"
          :class="{'border-danger': $v.tender.start_date.$dirty && !$v.tender.start_date.required}"
          id="start-date"
          class="date-picker"
          :weekdays="['Երկ', 'Երեք', 'Չոր', 'Հին', 'Ուրբ', 'Շբթ', 'Կիր']"
          :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
        />
      </div>
      <div class="form-group col-md-6">
        <label for="end-date">Ավարտ</label>
        <date-pick 
          v-model="$v.tender.end_date.$model"
          :isDateDisabled="previousEndDate"
          setTimeCaption='Ժամը՝'
          :pickTime="true"
          :format="'YYYY-MM-DD HH:mm'"
          :inputAttributes="{readonly: true}"
          :class="{'border-danger': $v.tender.end_date.$dirty && !$v.tender.end_date.required}"
          id="end-date"
          class="date-picker"
          :weekdays="['Երկ', 'Երեք', 'Չոր', 'Հին', 'Ուրբ', 'Շբթ', 'Կիր']"
          :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
        />
      </div>
      <div class="form-group col-md-6">
        <label for="exampleFormControlSelect1">Մարզ</label>
        <select v-model="$v.tender.regions.$model" class="form-control" id="exampleFormControlSelect1">
          <template v-for="region in regions">
            <option :value="region.id" :key="region.id">{{region.name}}</option>
          </template>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="type">Տեսակ</label>
        <select v-model="$v.tender.type.$model" class="form-control" id="type">
          <option value="PAPER">Թղթային</option>
          <option value="ELECTRONIC">Էլեկտրոնային</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <div class="row">
          <div class="col">
            <label class="m-0 w-100 btn btn-primary">
              <i class="fa fa-upload mr-1" aria-hidden="true"></i> Նախահաշվային գին <input @change="previewEstimatedFile" type="file" hidden>
            </label>
          </div>
          <div class="col row align-items-center justify-content-start">
            <div class="col">
              <input 
                v-model.number="$v.tender.estimated.$model"
                type="text"
                class="form-control"
                id="procurement-name-ru"
              >
            </div>
          </div>
          <div class="col-12">
            <div class="pt-2">Առավելագույնը 10ՄԲ</div>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6">
        <div class="row">
          <div class="col">
            <label class="m-0 w-100 btn btn-primary">
              <i class="fa fa-upload mr-1" aria-hidden="true"></i> Հրավեր <input @change="previewInvitationFile" type="file" hidden>
            </label>
          </div>
          <div class="col row align-items-center justify-content-start">
            <span>{{invitation_file_name}}</span>
          </div>
          <div class="col-12">
            <div class="pt-2">Առավելագույնը 10ՄԲ</div>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6">
        <div class="form-check form-check-inline">
          <input 
            v-model="$v.tender.guaranteed.$model"
            id="guaranteed"
            class="form-check-input"
            type="checkbox"
          >
          <label class="form-check-label" for="guaranteed">Երաշխիքով</label>
        </div>
      </div>
    </div>


    <div class="d-flex justify-content-end">
      <button @click="confirm" class="btn btn-gradient-success mt-3" type="button" :disabled="isSaving">
        <span v-if="isSaving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Հաստատել
      </button>
    </div>
    <confirm-modal confirmBtnText="Հաստատել" declineBtnText="Չեղարկել"/>

  </div>
</template>

<script>
  import 'vue-date-pick/dist/vueDatePick.css';
  import { required } from 'vuelidate/lib/validators'
  import DatePick from 'vue-date-pick';

  export default {
    name: 'CreateTenderForm',
    props: ['rows'],
    components: {
      ConfirmModal: () => import('@/components/helpers/ConfirmModal'),
      DatePick,
    },
    data() {
      return {
        isSaving: false,
        procedureTypes: [],
        regions: [],
        estimated_file_name: '',
        invitation_file_name: '',
        tender: {
          title: '',
          passwordTender: '',
          start_date: '',
          end_date: '',
          regions: 11,
          type: 'PAPER',
          estimated: '', // 
          estimated_file: { },
          invitation_file: { },
          guaranteed: false, // 
          cpv: [], // 
        },
      }
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
      organizedRows() {
        return this.$store.getters['organize/organizedRows']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {
      this.$client.get('manager/getTenderFormSelectValues').then(({data}) => {
        this.procedureTypes = data.procedure
        this.regions = data.regions
      })
    },
    methods: {
      previousDate(date){
        var d = new Date();
        var x = 1;
        return date < d.setDate(d.getDate() - x)
      },
      previousEndDate(date){
        var d = new Date(this.tender.start_date);
        var x = 0;
        return date < d.setDate(d.getDate() - x)
      },
      previewEstimatedFile(event){
        const file = event.target.files[0]
        if(file.size < 100000000){
          this.tender.estimated_file = file;
          this.tender.estimated = file.name
          this.estimated_file_name = file.name
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ընտրված ֆայլի առավելագույն ծավալը պետք է լինի 10ՄԲ'
          })
        }
      },
      previewInvitationFile(event){
        const file = event.target.files[0]
        if(file.size < 100000000){
          this.tender.invitation_file = file;
          this.invitation_file_name = file.name
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ընտրված ֆայլի առավելագույն ծավալը պետք է լինի 10ՄԲ'
          })
        }
      },
      confirm() {
        if(!this.$v.tender.$invalid) {
          if(this.rows.length){
            this.$modal.show('confirm-modal', {
              msg: '',
              callback: async () => {
                this.isSaving = true;
                // const newEndDate = this.$moment(this.tender.end_date, "YYYY-MM-DD HH:mm");
                // this.tender.end_date = newEndDate.format("YYYY-MM-DD HH:mm");
                const formData = new FormData();
                Object.keys(this.tender).forEach((key) => {
                  formData.append(key, this.tender[key]);
                });
                const cpvArray = this.rows.map(row => row.id);
                formData.append('cpv', JSON.stringify(cpvArray));
                this.$client.post('manager/add/tender', formData).then(({data}) => {
                  if(data){
                    this.$notify({
                      group: 'foo',
                      type: 'success',
                      text: 'Հաջողությամբ հաստատված է'
                    })
                    this.isSaving = false;
                    this.$router.push('/organizator/tenders/list')
                  }
                })
              }
            })
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Ընտրեք գոնե մեկ գնման առարկա հաստատելու համար'
            })
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }
      },
    },
    validations() {
      const rules = {
        tender: {
          passwordTender: { },
          title: { required },
          regions: { required },
          start_date: { required },
          end_date: { required },
          type: { required },
          estimated: { },
          estimated_file: { },
          invitation_file: { required },
          guaranteed: { required },
        },
      }
      return rules
    }
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
</style>
